import Image from "next/image";

export default function AuthRightSidebar() {
  return (
    <Image
      src={`/assets/auth/auth.png`}
      className="h-auto w-full object-cover object-center"
      alt="Auth Right Sidebar Image"
      width={0}
      height={0}
      quality={100}
      style={{
        height: "100%",
        width: "100%",
      }}
      sizes="100vw"
      priority
    />

    // <Image
    //   src={`/assets/auth/auth.png`}
    //   alt="Auth Right Sidebar Image"
    //   width={0}
    //   height={0}
    //   quality={100}
    //   style={{
    //     height: "100%",
    //     width: "100%",
    //   }}
    //   sizes="100vw"
    //   className=" object-cover"
    //   priority
    // />
  );
}
